var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhiteWithWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.06 142.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{stroke:#fff;stroke-width:13px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 424.82,
    height: 142.86
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-white-with-white-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.68,33.29v84.26h-.44L180.59,66.4l.33,47.85H164.75V30.1h.66L222,82l-.33-48.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.19,53.31a41.84,41.84,0,0,1,15.07-15.23,40.35,40.35,0,0,1,41.25,0,42.85,42.85,0,0,1,15.18,15.23,40.41,40.41,0,0,1,0,41.25,42.27,42.27,0,0,1-15.18,15,41.21,41.21,0,0,1-41.31,0,41.41,41.41,0,0,1-15-15,41,41,0,0,1,0-41.25Zm14.3,33.55a25.22,25.22,0,0,0,9.13,9.41,24.42,24.42,0,0,0,12.81,3.46,23.17,23.17,0,0,0,12.43-3.46,24.57,24.57,0,0,0,8.8-9.35,28.15,28.15,0,0,0-.11-26.24,25.14,25.14,0,0,0-9-9.4,24.59,24.59,0,0,0-25.19,0,25.09,25.09,0,0,0-9,9.4,26.72,26.72,0,0,0-3.3,13.2A25.9,25.9,0,0,0,273.49,86.86Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.52,33.29v15.4H368.25V66H403v15.4H368.25V98.85h40.81v15.4H352.3v-81ZM384.09,28h-9.35l8.58-14.85h17.05Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,15.48c8.14-13,13.47-11.23,11.89,4.07l-11,106.58c-1.13,11-8.34,13.53-16.11,5.67L79.16,116c-10.81-10.93-13-30.38-4.84-43.43Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.66,127.39c-8.14,13-13.46,11.22-11.88-4.08l11-106.57c1.13-11,8.35-13.53,16.11-5.68L49.46,26.83c10.82,10.94,13,30.38,4.84,43.43Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteWithWhiteText);
export default __webpack_public_path__ + "static/media/logo-white-with-white-text.73f4586d7fae615e66f0f8b4777b9294.svg";
export { ForwardRef as ReactComponent };